import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, SxProps, Theme, Tooltip } from '@mui/material';
import React from 'react';

import { Label } from './';

interface ILabelWithErrorProps {
  children: React.ReactNode;
  error?: boolean;
  errorTooltip?: string;
  sx?: SxProps<Theme>;
  marginBottom?: string | number;
}

export const LabelWithError: React.FC<ILabelWithErrorProps> = ({ children, error, errorTooltip, sx, marginBottom }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        marginBottom: error ? '3px' : marginBottom || '5px',
        ...sx,
      }}
    >
      <Label sx={{ margin: 0 }}>{children}</Label>
      {error && errorTooltip && (
        <Tooltip title={errorTooltip} arrow placement="top">
          <ErrorOutlineIcon color="error" fontSize="small" />
        </Tooltip>
      )}
    </Box>
  );
};
